import { Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';

interface Props {
  location: {
    address: string;
    maxSuites: number;
    availableSuites: number[];
  };
}

function SuitesList({ location: { availableSuites, maxSuites } }: Props) {
  const { locationId } = useParams() as { locationId: string };
  const navigate = useNavigate();

  function handleRowClick(suite: number, goTo: boolean) {
    if (goTo) {
      navigate(`/locations/${locationId}/suite/${suite}`);
    }
  }

  return (
    <TableContainer>
      <Table variant="simple">
        {!availableSuites.length && (
          <TableCaption>This location does not have any contracts</TableCaption>
        )}
        <Thead>
          <Tr>
            <Th>suite</Th>
            <Th>in use</Th>
          </Tr>
        </Thead>
        <Tbody>
          {Array.from(Array(maxSuites).keys()).map(suite => {
            const inUse = !availableSuites.includes(suite + 1);
            return (
              <Tr
                bgColor={inUse ? '#F2F2FE' : ''}
                boxShadow={inUse ? 'base' : ''}
                cursor={inUse ? 'pointer' : ''}
                key={suite}
                onClick={() => handleRowClick(suite + 1, inUse)}
              >
                <Td>Suite #{suite + 1}</Td>
                <Td>{inUse ? 'Yes' : 'No'}</Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
}

export default SuitesList;
